import React, { useState } from 'react';
import { Card, Table, Tag, Typography, Button, Select, Input, Space, Form, Drawer, message, Tooltip, Popconfirm } from 'antd';
import { SearchOutlined, ReloadOutlined, PlusOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const STATUS_MAP = {
  pending: { label: '对方待确认', color: 'processing' },
  authorized: { label: '授权成功', color: 'green' },
  rejected: { label: '对方已拒绝', color: 'red' },
  revoked: { label: '已撤销', color: 'default' },
  cancelled: { label: '对方取消授权', color: 'default' },
};

// TODO: 联调时替换
const MOCK_DATA = [
  { key: '1', productName: '智能摄像机 Q1', productId: 'PROD_001', productEntName: '深圳智联科技有限公司', productEntId: 'ENT_001', saasName: '智能家居控制平台', saasId: 'SAAS_ENT001_A3F8', saasEntName: '深圳智联科技有限公司', saasEntId: 'ENT_001', status: 'authorized' },
  { key: '2', productName: '智能门锁 D1', productId: 'PROD_002', productEntName: '杭州云智设备有限公司', productEntId: 'ENT_008', saasName: '云智设备管家', saasId: 'SAAS_ENT008_B2D4', saasEntName: '杭州云智设备有限公司', saasEntId: 'ENT_008', status: 'pending' },
  { key: '3', productName: '4G室外球机', productId: 'PROD_003', productEntName: '北京万物互联科技有限公司', productEntId: 'ENT_003', saasName: '万物互联IoT平台', saasId: 'SAAS_ENT003_C7E1', saasEntName: '北京万物互联科技有限公司', saasEntId: 'ENT_003', status: 'rejected' },
  { key: '4', productName: '红外枪机', productId: 'PROD_004', productEntName: '星云互联有限公司', productEntId: 'ENT_005', saasName: '智能家居控制平台', saasId: 'SAAS_ENT001_A3F8', saasEntName: '深圳智联科技有限公司', saasEntId: 'ENT_001', status: 'cancelled' },
  { key: '5', productName: '全景摄像机 P360', productId: 'PROD_005', productEntName: '深圳智联科技有限公司', productEntId: 'ENT_001', saasName: '云智设备管家', saasId: 'SAAS_ENT008_B2D4', saasEntName: '杭州云智设备有限公司', saasEntId: 'ENT_008', status: 'revoked' },
];

// mock 产品列表
const MOCK_PRODUCTS = [
  { name: '智能摄像机 Q1', id: 'PROD_001', entName: '深圳智联科技有限公司', entId: 'ENT_001' },
  { name: '智能门锁 D1', id: 'PROD_002', entName: '杭州云智设备有限公司', entId: 'ENT_008' },
  { name: '4G室外球机', id: 'PROD_003', entName: '北京万物互联科技有限公司', entId: 'ENT_003' },
];

const MOCK_PARTNERS = [
  { id: 'ENT_001', name: '深圳智联科技有限公司' },
  { id: 'ENT_008', name: '杭州云智设备有限公司' },
  { id: 'ENT_003', name: '北京万物互联科技有限公司' },
];

const AuthorizedSaaS = () => {
  const [data, setData] = useState(MOCK_DATA);
  const [loading, setLoading] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [, setSearchType] = useState('name');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [saasId, setSaasId] = useState('');
  const [saasResult, setSaasResult] = useState(null);

  const handleSaasSearch = () => {
    if (saasId === 'test') {
      setSaasResult({ saasName: '智能家居控制平台', saasId: 'SAAS_ENT001_A3F8' });
    } else { setSaasResult(null); message.warning('未查询到该 SaaS'); }
  };

  const handleAdd = () => {
    message.success('已提交授权');
    setDrawerVisible(false); setSelectedProduct(null); setSelectedPartner(null); setSaasId(''); setSaasResult(null);
  };

  const onSearch = () => { setLoading(true); setTimeout(() => setLoading(false), 300); };
  const onReset = () => { };

  const columns = [
    { title: '授权产品', key: 'product', width: 180, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.productName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.productId}</Text></div>) },
    { title: '产品企业', key: 'pEnt', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.productEntName}</div><Text type="secondary" style={{ fontSize: 12 }}>ID: {r.productEntId}</Text></div>) },
    { title: 'SaaS应用', key: 'saas', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.saasName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.saasId}</Text></div>) },
    { title: 'SaaS企业', key: 'sEnt', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.saasEntName}</div><Text type="secondary" style={{ fontSize: 12 }}>ID: {r.saasEntId}</Text></div>) },
    {
      title: '授权状态', dataIndex: 'status', key: 'status', width: 160,
      render: v => {
        const c = STATUS_MAP[v];
        return (
          <div>
            <Tag color={c.color}>{c.label}</Tag>
            {v === 'failed' && <Tooltip title={/* TODO */ ''}><Text type="danger" style={{ fontSize: 11 }}>点击查看原因</Text></Tooltip>}
          </div>
        );
      }
    },
    {
      title: '操作', key: 'action', width: 100, fixed: 'right',
      render: (_, r) => {
        if (r.status === 'pending') return (
          <Popconfirm title="确认撤销此授权申请？" onConfirm={() => { setData(prev => prev.map(d => d.key === r.key ? { ...d, status: 'revoked' } : d)); message.success('已撤销'); }} okText="确认" cancelText="取消">
            <Button type="link" size="small" danger>撤销</Button>
          </Popconfirm>
        );
        return <Text type="secondary">—</Text>;
      }
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={4}>授权SaaS</Title>
      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Form layout="inline">
          <Form.Item style={{ marginBottom: 0 }}>
            <Space.Compact>
              <Select defaultValue="name" style={{ width: 130 }}><Select.Option value="name">授权产品</Select.Option><Select.Option value="id">产品ID</Select.Option></Select>
              <Input placeholder="请输入" allowClear style={{ width: 150 }} />
            </Space.Compact>
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}><Input placeholder="SaaS ID" allowClear style={{ width: 180 }} /></Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Select placeholder="授权状态" allowClear style={{ width: 140 }}>
              <Select.Option value="pending">对方待确认</Select.Option>
              <Select.Option value="authorized">授权成功</Select.Option>
              <Select.Option value="rejected">对方已拒绝</Select.Option>
              <Select.Option value="revoked">已撤销</Select.Option>
              <Select.Option value="cancelled">对方取消授权</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}><Space><Button type="primary" icon={<SearchOutlined />} onClick={onSearch}>查询</Button><Button icon={<ReloadOutlined />} onClick={onReset}>重置</Button></Space></Form.Item>
        </Form>
      </Card>
      <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => { setSelectedProduct(null); setSelectedPartner(null); setSaasId(''); setSaasResult(null); setDrawerVisible(true); }}>添加授权</Button>
        </div>
        <Table columns={columns} dataSource={data} rowKey="key" loading={loading} bordered={false} scroll={{ x: 1000 }} pagination={{ showSizeChanger: true, showTotal: t => `共 ${t} 条记录`, pageSize: 10 }} />
      </Card>

      <Drawer title="添加授权" open={drawerVisible} onClose={() => setDrawerVisible(false)} width={560}
        footer={<div style={{ textAlign: 'right' }}><Button onClick={() => setDrawerVisible(false)}>取消</Button><Button type="primary" style={{ marginLeft: 8 }} disabled={!selectedProduct || !saasResult} onClick={handleAdd}>确认授权</Button></div>}>
        <Form.Item label="授权产品">
          <Select showSearch placeholder="搜索并选择产品" optionFilterProp="children" value={selectedProduct}
            onChange={v => { setSelectedProduct(v); setSearchType('name'); }}
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
            {MOCK_PRODUCTS.map(p => (<Select.Option key={p.id} value={p.id}>{p.name}（{p.id}）</Select.Option>))}
          </Select>
          {selectedProduct && (() => { const p = MOCK_PRODUCTS.find(x => x.id === selectedProduct); return <div style={{ marginTop: 8, padding: '8px 12px', background: '#fafafa', borderRadius: 6 }}><Text type="secondary" style={{ fontSize: 12 }}>产品ID：{p?.id} | 企业：{p?.entName}（{p?.entId}）</Text></div>; })()}
        </Form.Item>
        <Form.Item label="合作企业">
          <Select showSearch placeholder="搜索并选择合作企业" optionFilterProp="children" value={selectedPartner}
            onChange={setSelectedPartner}
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
            {MOCK_PARTNERS.map(p => (<Select.Option key={p.id} value={p.id}>{p.name}</Select.Option>))}
          </Select>
          {selectedPartner && <Text type="secondary" style={{ display: 'block', marginTop: 4, fontSize: 12 }}>企业ID：{selectedPartner}</Text>}
        </Form.Item>
        <Form.Item label="SaaS ID">
          <Space.Compact style={{ width: '100%' }}>
            <Input placeholder="输入 SaaS ID" value={saasId} onChange={e => setSaasId(e.target.value)} />
            <Button type="primary" onClick={handleSaasSearch}>查询</Button>
          </Space.Compact>
          {saasResult && <div style={{ marginTop: 8, padding: '8px 12px', background: '#fafafa', borderRadius: 6 }}><div style={{ fontWeight: 500 }}>{saasResult.saasName}</div><Text type="secondary" style={{ fontSize: 12 }}>ID: {saasResult.saasId}</Text></div>}
        </Form.Item>
      </Drawer>
    </div>
  );
};

export default AuthorizedSaaS;
